import React from 'react';
import { motion } from 'framer-motion';
export function CourseSection() {
  return <section className="py-24 px-6 bg-white" data-id="element-67">
      <div className="max-w-3xl mx-auto text-center" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mb-6" data-id="element-70">
            Comprar bien no es suerte
          </h2>

          <p className="text-lg text-gray-600 leading-relaxed mb-4" data-id="element-71">
            La mayoría de las personas parte viendo propiedades sin estrategia.
            Ahí es donde se equivocan.
          </p>

          <p className="text-lg text-gray-900 font-semibold leading-relaxed" data-id="element-72">
            Nosotros te ayudamos a hacerlo bien desde el principio.
          </p>
        </motion.div>
      </div>
    </section>;
}